import React from "react";
import { SloganText } from "../../Styles/styledComponents/Text.js";
import useMediaQuery from "../../Styles/useMediaQuery.jsx";

export const Slogan = (props) => {
    const { label} = props.data;
    const isDesktop = useMediaQuery("(min-width: 575px)");
  return (
    <>
     <SloganText  style={{fontSize: isDesktop ? "4em " : "3.4em"}} >{label}</SloganText>
    </>
  );
};



